import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { z } from "zod";
import DocumentRecordsTable from "@/components/document-records/document-records-table";

const documentsSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  status: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/documents/")({
  validateSearch: documentsSearchSchema,
  component: DocumentsPage,
});

function DocumentsPage() {
  const searchParams = Route.useSearch();

  return (
<RouteGuardPermissions
      permissions={[{ module: "document_records", actions: ["read"] }]}>
      
    <div className="flex-1 flex flex-col min-h-0">
      <div className="flex-1 min-h-0">
        <DocumentRecordsTable
          currentPage={searchParams.page}
          basePath="/documents"
          searchParams={searchParams}
        />
      </div>
    </div>
  
    </RouteGuardPermissions>
  );
}
